import React, { useState } from 'react';
import { Stack } from '../../../../atoms/stack/Stack';
import { LinkButton } from '../../../../atoms/linkButton/LinkButton';
import { Row } from '../../../../atoms/row/Row';
import { Typography } from '../../../../atoms/typography/Typography';
import { Arrow } from '../../../../../../static/icons/arrow';
import SearchInputMobile from '../../../../molecules/shared/navigationBar/searchInputMobile/SearchInputMobile';
import CategoriesMobileList from './categoriesMobileList/CategoriesMobileList';

const MobileMenu = ({ data, query, search, t }) => {
  const [categories, setCategories] = useState(null);
  const { menuItems } = data;

  return (
    <Stack className="bg-transparent flex-1 items-start justify-start overflow-y-auto p-4 h-[calc(100vh-6rem)]">
      {categories ? (
        <CategoriesMobileList
          categories={categories}
          backAction={() => setCategories(null)}
          t={t}
        />
      ) : (
        <>
          {search && (
            <SearchInputMobile
              handleInputChange={search.onSearchChange}
              onBlur={() => {}}
              results={search.searchSuggestions}
              query={search.searchValue}
              t={t}
            />
          )}
          {query.length === 0 &&
            menuItems.map((tab) =>
              tab.id === 'categories' ? (
                <Row
                  key={tab.title}
                  onClick={() => setCategories(tab.children)}
                  className="items-center global-hover px-4 py-2"
                >
                  <Typography
                    fontVariant="lg"
                    textAlign="right"
                    className="font-bold"
                  >
                    {tab?.title}
                  </Typography>
                  <Arrow color="black" direction="right" />
                </Row>
              ) : (
                <LinkButton
                  key={tab.id}
                  href={tab.href}
                  className="w-fit text-clamp-lg font-bold !text-customGray-900"
                  variant="transparent"
                  label={tab.title}
                />
              )
            )}
        </>
      )}
    </Stack>
  );
};

export default MobileMenu;
